export default function WorkerFactory(options) {
  return new Worker(
    /* webpackChunkName: "highlight_worker" */
    new URL('./highlight_worker.js?worker_chunk', import.meta.url),
    { type: 'module', name: options && options.name },
  );
}
